import * as queryString from "query-string";

export const getDashboardLink = (path: string, params?: Record<string, unknown>) => {
  const stringifyParams = queryString.stringify({ ...params });
  if (stringifyParams) {
    return `${path}?${stringifyParams}`;
  }
  return `${path}`;
};
